// Allowlist de hosts para agentes locales — impresión y balanza hablan con el
// mismo proceso (`vuelto-print-agent` :9310), así que la regla es una sola:
// localhost + IPs privadas LAN (agente en otra PC del local). #795/#796.
const LOCAL_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);

function isPrivateLanHost(hostname: string): boolean {
  const m = hostname.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
  if (!m) return false;
  const [a, b] = [Number(m[1]), Number(m[2])];
  return (
    a === 10 ||
    (a === 172 && b >= 16 && b <= 31) ||
    (a === 192 && b === 168) ||
    (a === 169 && b === 254)
  );
}

export function isAllowedLocalAgentUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
    // IPv6 llega con corchetes ("[::1]") según plataforma — normalizar.
    const hostname = parsed.hostname.replace(/^\[|\]$/g, '');
    return LOCAL_HOSTS.has(hostname) || isPrivateLanHost(hostname);
  } catch {
    return false;
  }
}
